var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update"},[_c('h2',{staticClass:"qjc-fts-20 qjc-c-dark qjc-ftw-500"},[_vm._v("礼品卡销售统计")]),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v("会员链接")]),_c('div',{staticClass:"list"},_vm._l((25),function(item){return _c('div',{staticClass:"item"},[_vm._v(_vm._s(item))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }